module.exports = __webpack_public_path__ + "static/media/siterraBg1.cf2421cb.jpg";